import { JugglingScreen } from "@motleyhand/design"
import { useGetProductsQuery } from "./api"
import ProductCard from "./ProductCard"
import { Feature, useFeatureEnabledQuery } from "@/feature"

type Props = {
  page: "pricing" | "purchase"
  className?: string
}

export default function Products({ page, className }: Props) {
  const { data: products, isLoading: isProductsLoading } = useGetProductsQuery()
  const { data: enterpriseFeature, isLoading: isFeatureLoading } =
    useFeatureEnabledQuery(Feature.Enterprise)

  const baseProducts = products?.filter(
    (product) => product.productType === "base",
  )
  const addonProducts = products?.filter(
    (product) => product.productType === "addon",
  )

  if (isProductsLoading) {
    return <JugglingScreen />
  }

  return (
    <div className={className}>
      <div className="grid max-w-6xl grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-4">
        {baseProducts?.map((product) => (
          <ProductCard key={product.id} product={product} page={page} />
        ))}
        {addonProducts?.map((product) => (
          <ProductCard key={product.id} product={product} page={page} />
        ))}
      </div>
      {page === "pricing" && !isFeatureLoading && (
        <p className="p-4">
          {enterpriseFeature
            ? "Need more concurrency, seats, or enterprise features like SSO and audit logs? Add-ons available after signup."
            : "Need more concurrency or seats? Add-ons available after signup."}
        </p>
      )}
    </div>
  )
}
